import { Button } from "@material-ui/core";
import ThumbsUpDownIcon from "@material-ui/icons/ThumbsUpDown";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import { UserResourceDocument } from "@repositories/userResource/types";
import { retrieveUserResource } from "@requests/userResources/retrieve";
import { triggerRateUserResource } from "@utilities/web/triggerRateUserResource";
import React from "react";

interface Props {
  resourceId: string;
  resourceType: string;
  userResource?: UserResourceDocument;
  onUserResource?: (userResource: UserResourceDocument) => void;
}

export default function UserResourceRateButton(props: Props): JSX.Element {
  const { resourceId, resourceType } = props;

  const [userResource, setUserResource] = React.useState<UserResourceDocument>(
    props.userResource,
  );

  console.log({ userResource });

  const like = userResource?.meta?.like || false;

  const icon = like ? <ThumbUpAltIcon /> : <ThumbsUpDownIcon />;
  const color = like ? "primary" : "default";

  const onUserResource = (updatedUserResource: UserResourceDocument) => {
    return props.onUserResource
      ? props.onUserResource(updatedUserResource)
      : null;
  };

  const onClick = () => {
    triggerRateUserResource(resourceId, resourceType, !like).then(
      setUserResource,
    );
  };

  const getUserResource = () => {
    retrieveUserResource({ resource: resourceId, type: resourceType }).then(
      setUserResource,
    );
  };

  React.useEffect(() => {
    getUserResource();
  }, []);

  React.useEffect(() => {
    onUserResource(userResource);
  }, [userResource]);

  return (
    <Button startIcon={icon} onClick={onClick} color={color}>
      {like ? "Liked" : "Like"}
    </Button>
  );
}
